(function documentControllerDefinition() {
    'use strict';

    angular.module('LawBook')
        .controller('LawBookFindController', [
            '$scope', 'config', '$state', '$translate', 'errorsExtend', 'documentService', 'documentTypeService', 'authExtend', 'storageService', 'fileService', 'fileDownloader', '$q', '$filter','organizationalUnitService',
            function paysheetFindController($scope, config, $state, $translate, errors, documentService, documentTypeService, auth, storageService, fileService, fileDownloader, $q, $filter, organizationalUnitService) {

                $scope.find = storageService.getDocumentFilter();
                $scope.showAdd = auth.isInRole('LAWBOOK WRITE');
                $scope.showSign = false;
                $scope.canSign = false;
                $scope.showAdd = auth.isInRole('LAWBOOK WRITE');

                $scope.maxSearchCaracters = config.searchTableMaxLength();
                // DOCUMENTCONTAINER WRITE

                $scope.loadActions = function (dtId) {
                    documentTypeService.isDoctypeInRole(['LAWBOOK DOWNLOAD'], dtId).then(function (r) { $scope.downloadBtn = r; });
                    documentTypeService.isDoctypeInRole(['LAWBOOK READ'], dtId).then(function (r) { $scope.viewPDFBtn = r; });
                    documentTypeService.isDoctypeInRole(['DOCUMENTVERSION READ'], dtId).then(function (r) { $scope.versionView = r; });
                    documentTypeService.isDoctypeInRole(['DOCUMENTVERSIONED WRITE', 'LAWBOOK WRITE'], dtId).then(function (r) { $scope.modifyOptions = r; });
                    documentTypeService.isDoctypeInRole(['FILE MASSIVE DOWNLOAD'], dtId).then(function (r) { $scope.masiveDownloadOptions = r; });
                }

                $scope.fullTextMinLength = config.fullTextMinLength();

                $scope.headers = [];
                $scope.sortableHeaders = [];
                $scope.items = [];

                $scope.all = { name: "All", id: 0 };

                $scope.aux = {
                    selectedDocumentTypes: [],
                    categoires: []
                };

                $scope.data = {
                    currentPage: 1,
                    totalItems: 0,
                    itemsPerPage: 15,
                    from: 0
                };

                $scope.accordionState = {
                    isOpen: true
                };

                $translate(['PaginationNext', 'PaginationPrev', 'PaginationFirstFem', 'PaginationLastFem'])
                    .then(function (translated) {
                        $scope.paginatorTranslations = {
                            nextText: translated.PaginationNext,
                            previousText: translated.PaginationPrev,
                            lastText: translated.PaginationLastFem,
                            firstText: translated.PaginationFirstFem
                        };
                    });

                $scope.hideAllVersion = !auth.isInRole('DOCUMENTVERSION READ');
                $scope.containerOptions = auth.isInRole('DOCUMENTCONTAINER WRITE');

                function checkType(value) {

                    for (var i in $scope.find.selectedDocumentTypes) {
                        if ($scope.find.selectedDocumentTypes.hasOwnProperty(i)) {
                            if ($scope.find.selectedDocumentTypes[i].id === value.id) {
                                return true;
                            }
                        }
                    }
                    return false;
                }

                $scope.Load = function () {
                    $scope.items = [];
                    $scope.documentTypes = [];
                    $scope.showResult = false;
                    $scope.itemsTmp = [];
                    $scope.aux = {
                        selectedDocumentTypes: [],
                        categoires: []
                    };

                    $scope.checkAll = false;

                    $scope.auxDocumentType = {};
                    $scope.auxContainerType = {};
                    $scope.optionsContainerTypes = [];
                    
                    $scope.find = storageService.getDocumentFilter();

                    organizationalUnitService.getOuTReeControl().then(function (result) {
                        $scope.organizationalUnits = result;
                        $scope.organizationalUnits.unshift({
                            id: -1,
                            entityDescription: '[Todas]'
                        });

                        $scope.find.organizationalUnit = $scope.organizationalUnits[0];
                    }, function (error) {
                        errors.showError(error);
                        });

                    documentTypeService.getBySystemName('_Ley', 'Detail', 'LAWBOOK READ').then(function (result) {
                        $scope.documentTypeName = result.name;
                        if ($scope.find.DocumentTypes == null) {
                            $scope.LoadDocumentTypeMetadata(result);
                        }

                        if ($scope.find.DocumentTypes.length > 0) {
                            $scope.findDocuments();
                        }

                    }, function (error) {
                        errors.showError(error);
                    });


                    $scope.documentContainFilesFilter();

                    $translate(['SearchCriteria']).then(function (translated) {

                        $scope.title = translated.SearchCriteria;
                        $scope.showUserQuery = false;
                    });
                };

                $scope.clean = function () {
                    $scope.aux.selectedDocumentTypes = [];
                    storageService.clearDocumentFilter();
                    $scope.showUserQuery = false;
                    $scope.userQuerySelected = '';
                    $scope.showBtnSave = true;
                    $scope.showBtnSaveAs = false;

                    $scope.find = storageService.getDocumentFilter();

                    $scope.loadDocumentTypes();

                    $scope.items = [];
                    $scope.accordionState.isOpen = true;
                    $scope.showResult = false;
                };

                $scope.LoadDocumentTypeMetadata = function (documentType) {

                    var documentDocType =
                        {
                            SystemName: documentType.systemName,
                            documentTypeName: documentType.name,
                            documentTypeId: documentType.id,
                            metadatas: []
                        };

                    documentType.metadata.forEach(function (metadata) {
                        if (metadata.metadataSystemName === '_estadoLLS' && metadata.optionValues) {
                            var states = JSON.parse(metadata.optionValues);
                            for (var i = 0; i < states.length; i++) {
                                if (states[i].value == '06' || states[i].value == '103' || states[i].value == 'E') {
                                    $scope.find.readOnlyStates.push(states[i]);
                                }
                            }
                        }

                        if (metadata.isSearchCriteria) {

                            documentDocType.metadatas.push(
                                {
                                    idObject: documentDocType.documentTypeId + '' + metadata.metadataId,
                                    metadataId: metadata.metadataId,
                                    metadataValueFrom: undefined,
                                    metadataValueTo: undefined,
                                    metadataSearchTypeFrom: undefined, // cada control pisa el valor
                                    metadataSearchTypeTo: undefined, // cada control pisa el valor
                                    metadataType: metadata.metadataType,
                                    metadataSystemName: metadata.metadataSystemName,
                                    metadataLabel: metadata.metadataLabel,
                                    metadataOptions: metadata.optionValues,
                                    maskOptions: metadata.maskOptions,
                                    metadataIsMultivalue: metadata.isMultivalue,
                                    metadataIsAutoComplete: metadata.metadataSystemName === '_estadoLLS' || metadata.metadataSystemName === '_tnomina'
                                });
                        }
                    });

                    if ($scope.find.DocumentTypes == null) {
                        $scope.find.DocumentTypes = [];
                    }

                    $scope.find.DocumentTypes.push(documentDocType);
                };

                $scope.selectDocumentType = function (documentType) {
                    documentTypeService.getById(documentType.id, 'Detail', 'DOCUMENT READ').then(function (result) {
                        $scope.LoadDocumentTypeMetadata(result);
                    }, function (error) {
                        errors.showError(error);
                    });
                };

                $scope.getIndex = function (selected, docType) {
                    var index = -1;

                    for (var i = 0; i < selected.length; i++) {
                        if ((selected[i]).id == docType.id) {
                            return i;
                        }
                    }
                    return index;
                }

                $scope.actionFind = function () {

                    $scope.items = [];
                    $scope.documentTypes = [];
                    $scope.showResult = false;

                    if ($scope.find.organizationalUnit && $scope.find.organizationalUnit.id) {
                        $scope.find.organizationalUnitId = $scope.find.organizationalUnit.id;
                    }

                    storageService.setMyDocumentFilter($scope.find);
                    if (!$scope.searchDocuments.$valid || $scope.find.DocumentTypes.length <= 0) {
                        $scope.searchDocuments.$setSubmitted();
                        errors.showError('VerifyFormData');
                        return false;
                    }

                    return $scope.findDocuments();

                };

                $scope.findDocuments = function () {
                    $scope.showResult = true;
                    if ($scope.searchDocuments && $scope.searchDocuments.$dirty) {
                        $scope.hasCalendarBtn = false;
                    }

                    $scope.find.selectedDocumentTypes = $scope.aux.selectedDocumentTypes;
                    storageService.setDocumentFilter($scope.find);

                    var filters = {
                        Complete: true,
                        DocumentTypes: [],
                        ContainerTypes: [],
                        organizationUnitIds: []
                    };

                    if ($scope.find.organizationalUnit && $scope.find.organizationalUnit.id) {
                        filters.organizationUnitIds.push($scope.find.organizationalUnit.id);
                    } else {
                        filters.organizationUnitIds.push(auth.getOrganizationId());
                    }

                    $scope.find.DocumentTypes.forEach(function (type) {
                        type.allVersion = $scope.find.allVersion;
                        type.Page = ((!type.Page) ? 1 : type.Page),
                            type.ItemPerPage = $scope.data.itemsPerPage;
                        type.organizationUnitIds = filters.organizationUnitIds;

                        var estadoLls = $filter('filter')(type.metadatas, { metadataSystemName: '_estadoLLS' }, true);
                        if (estadoLls.length > 0) {
                            $scope.showSign = auth.isInRole('LAWBOOK SIGN') && !$scope.find.readOnlyStates.some(function (e) {
                                return e.value === estadoLls[0].metadataValueFrom || estadoLls[0].metadataValueFrom === undefined || estadoLls[0].metadataValueFrom === null;
                            });
                        }

                        if (!type.OrderBy || type.OrderBy.length === 0) {
                            type.OrderBy = [];
                            type.OrderBy.push("m._peri");
                        }

                        filters.DocumentTypes.push(type);
                    });

                    $scope.documentContainFilesFilter();

                    $scope.parameters = {
                        documentHasFiles: $scope.find.documentHasFiles,
                        documentFullText: $scope.find.documentFullText,
                        documentTypes: filters.DocumentTypes
                    };

                    return documentService.advancedGet($scope.parameters).then(function getOk(result) {
                        $scope.findDocAndCont(result, false);
                    }, function getError(error) {
                        errors.showError(error);
                    });
                };

                $scope.findDocAndCont = function (result, isDocContFind) {
                    $scope.itemsTmp = result.values;

                    if ($scope.itemsTmp.length > 0) {
                        $scope.accordionState.isOpen = false;
                    }

                    $scope.items = $scope.itemsTmp;
                    $scope.documentTypes = result.documentTypes;
                    if ($scope.documentTypes.length > 0) {
                        var dt = $scope.find.DocumentTypes.filter(function (item) {
                            return item.showDetail;
                        })
                        var selectedDT = $scope.documentTypes.filter(function (item) {
                            if (dt.length > 0) {
                                return item.id == dt[0].documentTypeId;
                            }

                            return true;
                        })
                        selectedDT[0].selected = true;
                        $scope.loadActions($scope.documentTypes[0].id);
                        $scope.currentSelectedTypeIsShareable = $scope.documentTypes[0].isShareable;
                    }

                    $scope.headers = result.headers;
                    $scope.sortableHeaders = result.sortableHeaders;
                    $scope.data.totalItems = result.valuesCount;
                    $scope.data.from = result.valuesFrom;
                    $scope.data.currentPage = isDocContFind ? $scope.parameters.documentType.documentTypes[0].Page : $scope.parameters.documentTypes.DocumentTypes[0].Page;
                };

                $scope.pageFind = function () {
                    $scope.items = [];
                    var find = storageService.getDocumentFilter();

                    if (find.DocumentTypes.length <= 0) {
                        $scope.data.totalItems = 0;
                        errors.showError('VerifyFormData');
                        return;
                    }

                    var filters = {
                        PartialQuery: true,
                        DocumentTypes: [],
                        organizationUnitIds: [],
                        ContainerTypes: []
                    };

                    if ($scope.find.organizationalUnit && $scope.find.organizationalUnit.id) {
                        filters.organizationUnitIds.push($scope.find.organizationalUnit.id);
                    } else {
                        filters.organizationUnitIds.push(auth.getOrganizationId());
                    }

                    find.DocumentTypes.forEach(function (type) {
                        type.Page = $scope.data.currentPage,
                            type.ItemPerPage = $scope.data.itemsPerPage;
                        type.organizationUnitIds = filters.organizationUnitIds;
                        filters.DocumentTypes.push(type);
                    });

                    storageService.setDocumentFilter(find);

                    $scope.parameters = {
                        documentHasFiles: $scope.find.documentHasFiles,
                        documentFullText: $scope.find.documentFullText,
                        documentTypes: filters.DocumentTypes
                    };

                    return documentService.advancedGet($scope.parameters).then(function getOk(result) {
                        $scope.itemsTmp = result.values;

                        if ($scope.itemsTmp.length > 0) {
                            $scope.accordionState.isOpen = false;
                        }

                        $scope.items = $scope.itemsTmp;
                        $scope.headers = result.headers;
                        $scope.sortableHeaders = result.sortableHeaders;
                        $scope.data.totalItems = result.valuesCount;
                        $scope.data.from = result.valuesFrom;

                    }, function getError(error) {
                        errors.showError(error);
                    });

                };

                $scope.view = function (document) {
                    storageService.setStateBackFind('lawbook-find');
                    $state.go('lawbook-detail', { id: document.id });
                };

                $scope.viewPDF = function (document) {
                    storageService.setStateBackFind('lawbook-find');
                    $state.go('file-document-detail', { id: document.id, version: document.nroVersion });
                };

                $scope.downloadFilesDocument = function (document) {
                    return fileService.downloadFilesDocument(document.id).then(function (result) {

                        var success = fileDownloader.saveAs(result.value, document.name + '.zip');

                        if (!success) {
                            errors.showError('Api failed');
                        }

                    }, function (error) {
                        if (error.status === 204) {
                            errors.showWarning('The document has no files');
                        } else {
                            errors.showError('Api failed');
                        }
                    });
                };

                $scope.canEdit = function (document) {
                    var canEdit = true;
                    document.metadata.forEach(function (m) {
                        $scope.find.readOnlyStates.forEach(function (s) {
                            if (s.description === m) {
                                canEdit = false;
                            }
                        });
                    });

                    return canEdit;
                };

                $scope.edit = function (document) {
                    storageService.setStateBackFind('lawbook-find');
                    $state.go('lawbook-edit', { id: document.id });
                }

                $scope.selectType = function (type) {

                    $scope.currentSelectedTypeIsShareable = type.isShareable;

                    if (type.selected) {
                        return true;
                    };

                    for (var k = 0; k < $scope.documentTypes.length; k++) {
                        $scope.documentTypes[k].selected = false;
                    }
                    type.selected = true;

                    var find = storageService.getDocumentFilter();

                    var filters = {
                        PartialQuery: true,
                        DocumentTypes: [],
                        organizationUnitIds: [],
                        ContainerTypes: []
                    };

                    filters.organizationUnitIds.push(auth.getOrganizationId());

                    for (var i = 0; find.DocumentTypes.length > i; i++) {
                        if (find.DocumentTypes[i].documentTypeId === type.id) {
                            find.DocumentTypes[i].showDetail = true;
                        } else {
                            find.DocumentTypes[i].showDetail = false;
                        }
                        find.DocumentTypes[i].Page = 1,
                            find.DocumentTypes[i].ItemPerPage = $scope.data.itemsPerPage;
                        find.DocumentTypes[i].organizationUnitIds = filters.organizationUnitIds;
                        filters.DocumentTypes.push(find.DocumentTypes[i]);
                    };

                    storageService.setDocumentFilter(find);

                    $scope.parameters = {
                        documentHasFiles: $scope.find.documentHasFiles,
                        documentFullText: $scope.find.documentFullText,
                        documentTypes: filters.DocumentTypes
                    };

                    return documentService.advancedGet($scope.parameters).then(function getOk(result) {
                        $scope.itemsTmp = result.values;

                        if ($scope.itemsTmp.length > 0) {
                            $scope.isOpen = false;
                            $scope.closeOthers = true;
                        }
                        $scope.loadActions(type.id);

                        $scope.items = $scope.itemsTmp;
                        $scope.headers = result.headers;
                        $scope.sortableHeaders = result.sortableHeaders;
                        $scope.data.totalItems = result.valuesCount;
                        $scope.data.from = result.valuesFrom;
                        $scope.data.currentPage = 1;

                    }, function getError(error) {
                        errors.showError(error);
                    });

                };

                $scope.viewFromRow = function (event, document) {

                    if (event.target.id !== "options" && !(event.target.offsetParent !== null && event.target.offsetParent.id === "options")) {

                        if (event.target.parentElement != null && event.target.parentElement.id === "doc") {
                            $scope.view(document);
                        }
                    }
                };

                $scope.checkOutAll = function () {
                    var checkDocs = [];
                    if ($scope.items.length > 0) {
                        $scope.items.forEach(function (docu) {
                            if (docu.check) {
                                checkDocs.push(docu);
                            }
                        });
                    }

                    if (checkDocs.length <= 0) {
                        errors.showError('VerifyFormNoDocuments');
                        return;
                    }

                    return documentService.checkOutAll(checkDocs).then(function () {
                        errors.showSuccess('DocumentCheckOutSucces');
                        $scope.actionFind();
                        $scope.checkAll = false;
                    }, function (error) {
                        // TODO: Se deberían mostrar todos los errores en una ventana. 
                        // Por ahora se muestra el primero que es el error genérico.
                        errors.showError(error);
                        $scope.actionFind();
                        $scope.checkAll = false;
                    });
                };

                $scope.downloadAll = function () {
                    var downloadDocs = [];
                    if ($scope.items.length > 0) {
                        $scope.items.forEach(function (docu) {
                            if (docu.check) {
                                var docu = { id: docu.id, name: docu.name };
                                downloadDocs.push(docu);
                            }
                        });
                    }

                    if (downloadDocs.length <= 0) {
                        errors.showError('VerifyFormNoDocuments');
                        return;
                    }

                    return fileService.masiveDownloadFilesDocument(downloadDocs).then(function (result) {
                        var success = fileDownloader.saveAs(result.value, document.name + '.zip');

                        if (!success) {
                            errors.showError('Api failed');
                        }

                    }, function (error) {
                        if (error.status === 204) {
                            errors.showWarning('The document has no files');
                        } else {
                            errors.showError(error);
                        }
                    });
                };

                $scope.checkUnCheckAll = function () {
                    if ($scope.items.length > 0) {
                        $scope.items.forEach(function (docu) {
                            docu.check = $scope.checkAll;
                        });
                    }
                };

                $scope.add = function () {
                    $state.go('lawbook-add');
                };

                $scope.sign = function () {
                    var toSign = [];

                    $scope.items.forEach(function (document) {
                        if (document.check) {
                            toSign.push(document);
                        }
                    });

                    if (toSign.length == 0) {
                        errors.showWarning('SignNoDocuments');
                    } else {
                        documentService.setSignDocuments(toSign);
                        $state.go('lawbook-massive-sign');
                    }
                };

                $scope.sortColumn = function (header) {
                    if (header.isSortable) {
                        header.asc = !header.asc;
                        $scope.sortableHeaders.forEach(function (column) {
                            if (column.value == header.value) {
                                column.sorted = true;
                                column.asc = header.asc;

                                var selectedDt = $filter('filter')($scope.documentTypes, { selected: true }, true);

                                $scope.find.DocumentTypes.forEach(function (dt) {
                                    if (dt.documentTypeId === selectedDt[0].id) {
                                        dt.OrderBy = [];
                                        dt.OrderBy.push(column.metadataSystemName);
                                        dt.orderAscendent = column.asc;
                                    }
                                });

                                $scope.findDocuments();
                            }
                            else {
                                column.sorted = false;
                            }
                        });
                    }
                };

                $scope.documentContainFilesFilter = function () {

                    $scope.documentHasFilesChecked = {
                        checkedYes: false,
                        checkedNo: false,
                        checkedAll: false

                    };

                    switch ($scope.find.documentHasFiles) {
                        case "YES":
                            $scope.documentHasFilesChecked.checkedYes = true;
                            break;
                        case "NO":
                            $scope.documentHasFilesChecked.checkedNo = true;
                            break;
                        default:
                            $scope.documentHasFilesChecked.checkedAll = true;
                            $scope.find.documentHasFiles = 'ALL';
                            break;
                    }
                };

                $scope.Load();

                $scope.$watch('items', function (docs) {
                    $scope.canSign = !docs.some(function (doc) {
                        return doc.check;
                    });
                }, true);
            }])
        .directive('document', function () {
            return {
                restrict: 'E',
                link: function (scope, elem, attrs) {
                    if (attrs.ngClick || attrs.href === '' || attrs.href === '#') {
                        elem.on('click', function (e) {
                            e.preventDefault();
                        });
                    }
                }
            };
        });

})();